import React from 'react';

import { getGroceryItemPriceParts } from './groceryApi';

export function GroceryCardPackQty({ item }) {
  const parts = getGroceryItemPriceParts(item);
  if (!parts?.quantityLabel) return null;
  return <span className="buy-grocery-card-pack-qty">{parts.quantityLabel}</span>;
}

export default function GroceryCardPrice({ item }) {
  const parts = getGroceryItemPriceParts(item);
  if (!parts?.sellingPrice) {
    return (
      <div className="buy-grocery-card-pricing">
        <span className="buy-grocery-card-selling-price">—</span>
      </div>
    );
  }

  return (
    <div className="buy-grocery-card-pricing">
      <div className="buy-grocery-card-price-offers">
        <span className="buy-grocery-card-selling-price">{parts.sellingPrice}</span>
        {parts.showMrp && parts.mrp ? (
          <span className="buy-grocery-card-mrp">{parts.mrp}</span>
        ) : null}
      </div>
    </div>
  );
}
